import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";


//Im sorry this is named ontologies


function SynonymEditor(props){

    const { term, setEditedSynonyms, ontologySuggestions = false } = props
    const editor = useRef(null);
    const toggle = useSelector(state => state.setToggle.toggle);

    const [activeIndex, setActiveIndex] = useState(false);
    const [termHasSynonyms, setTermHasSynonyms] = useState(false);

    useEffect(()=>{
        if(term !== null && term !== undefined){
            setActiveIndex(true) 
            if(term.synonyms.length > 0){
                setTermHasSynonyms(true); 
                if(term.editedSynonyms){
                    editor.current.value = formatEditorText(term.editedSynonyms);
                }else{
                    editor.current.value = formatEditorText(term.synonyms);
                }
            }else{
                setTermHasSynonyms(false);
                editor.current.value = formatEditorText([]);
            }
        }else{
            setActiveIndex(false);
            setTermHasSynonyms(false); 
            editor.current.value = formatEditorText("");
        }

    },[term])

    function handleInput(event){
        
        let value = event.target.value;
        let wordRay = "";

        if(value.length > 0){
            wordRay = value.split("\n");

            for(let i = 0; i < wordRay.length; i++){
                if(i !== wordRay.length -1 && wordRay[i] == ""){
                    wordRay.splice(i, 1);
                    i--;
                }else{
                    wordRay[i] = wordRay[i].replace(/[\\\/\[\]\<\>]/ig, "");
                }
            }

            setEditedSynonyms([...wordRay]);
            setTermHasSynonyms(true);
        }else{
            setTermHasSynonyms(false);
        }


        editor.current.value = formatEditorText(wordRay);
       
    }

    function formatEditorText(wordRay){
        if(Array.isArray(wordRay)){
            
            let newText = "";
            
            for(let i = 0; i < wordRay.length; i++){
                newText += wordRay[i]

                if(i < wordRay.length - 1){
                    newText += "\n"
                }
            }

            return newText;

        }
        return "";
    }


    function fixLocation(offset){
        let element = document.getElementById("synonymEditor");
       
        if(element){
            let height = element.clientHeight/2
            let total = height + offset;
            return -total+"px"
        }
    }

    return (
        <div style={{width: "100%", height: "100%"}}>
                <textarea 
                    style={{
                        whiteSpace: "nowrap",
                        overflowX: "scroll",
                        position: "relative",
                        width: "100%",
                        height: "100%",
                        outline: "none",
                        zIndex: "200",
                        outline: "none",
                        border: "none",
                        resize: "none",
                        lineHeight: "2",
                        backgroundColor: toggle ? "" : "#777"
                    }}
                    className="appTextColor"
                    id="synonymEditor"
                    ref={editor}
                    disabled = {!activeIndex}
                    onInput={(e)=>{handleInput(e);}}
                    //onInput={(e)=>{handleInput(e); getOntoSuggestions();}}
                    //onClick={()=>{getOntoSuggestions(); setPressedEscape(false)}}
                >
                </textarea>
            
            {activeIndex && !termHasSynonyms &&
                <div className="centerEditortext"
                    style={{marginTop: fixLocation(15), zIndex: "201"}}
                >
                    <span className="font18pt appTextColor">Add Terms Here</span>
                </div>
            }
            {!activeIndex &&
                <div className="centerEditortext"
                    style={{marginTop: fixLocation(15)}}
                >
                    {ontologySuggestions?
                    <span className="font18pt appTextColor">Select a search term from the left</span> :
                    <span className="font18pt appTextColor">Search and select a term from the left</span>
                    }

                </div>
            }
        </div>
    );
}

export default SynonymEditor;
